import React from 'react';
import { withTheme } from 'emotion-theming';

import { ChartHierarchicalDropdown } from '@ihme/common/web/components';
import dropdownStyles from '../../theme/dropdown-styles';
import dropdownLabelStyles from '../../theme/dropdown-label-styles';

export default withTheme(props => (
    <ChartHierarchicalDropdown
        {...props}
        styles={dropdownStyles(props.theme)}
        labelStyles={dropdownLabelStyles(props.theme)}
    />
));
